export default __webpack_public_path__ + "static/media/signature--orange.547f214d.png";